import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { Cached, DataWithCache } from "@cervval.js/common/src/tools/cache.tools";
import { anyReallyAny } from "@cervval.js/common/tools";
import { APP_NAMES, LOCALES } from "../i18n/const/i18nConst";
import * as alert from "../i18n/masters/alert.master";
import * as common from "../i18n/masters/common.master";
import * as components from "../i18n/masters/components.master";
import * as errors from "../i18n/masters/error.master";
import * as planning from "../i18n/masters/planning.master";


export const GLOBAL_LOCALE_SERVICE = "GlobalLocaleService";


@Injectable(GLOBAL_LOCALE_SERVICE)
export class GlobalLocaleService extends DataWithCache {

    private _currentLocale: string = LOCALES.FR;

    /**
     * 
     * @param locale 
     */
    public setLocale(locale: string): void {
        switch (locale) {
            case LOCALES.FR:
                this._currentLocale = LOCALES.FR;
                break;

            case LOCALES.EN:
                this._currentLocale = LOCALES.EN;
                break;

            default:
                this._currentLocale = LOCALES.FR;
                break;
        }
    }
    /**
     * 
     * @returns 
     */
    public getLocale(): string {
        return this._currentLocale;
    }

    /** Get the i18n for a json path */
    @Cached()
    public translate(jsonPath: string, appName: APP_NAMES): string {
        const copy = this._mapDataWithAppName(appName);
        let translatedLabel = "";
        const split = jsonPath.split(".");
        if (split.length < 2 || split.length > 1 && split[1] === "") {
            translatedLabel = jsonPath;
        } else {
            const label = this._loop(copy, jsonPath);
            if (label !== null) {
                translatedLabel = label;
            } else {
                const globalLocale: GlobalLocaleService = new GlobalLocaleService();
                translatedLabel = this._loop({ ...errors }, `common.${globalLocale.getLocale()}.translation.notFound`);
                translatedLabel = translatedLabel.replace(/{{.*?}}/, jsonPath);

                // Quick ugly FIX 
                if (translatedLabel.includes("[")) {
                    const cleanTranslatedLabel = translatedLabel.replace("Traduction introuvable pour :", "");
                    translatedLabel = cleanTranslatedLabel.replaceAll("'", "");
                }
            }
        }
        return translatedLabel;
    }


    /**
     * 
     * @param obj 
     * @param key 
     * @returns 
     */
    private _loop(obj: anyReallyAny, key: string): string {

        const keys: string[] = Object.keys(obj);
        const keyChain: string[] = key.split(".");

        if (keys.includes(keyChain[0])) {
            const nextKeys = Object.keys(obj[keyChain[0]]);
            if (nextKeys !== undefined && nextKeys.length !== 0 && nextKeys.includes(keyChain[1])) {

                obj = obj[keyChain[0]];
                keyChain.splice(0, 1);
                key = keyChain.join(".");

                return this._loop(obj, key);

            } else if (typeof obj[keyChain[0]] === "string") {
                return obj[keyChain[0]];
            } else {
                return null as anyReallyAny;
            }
        } else {
            return null as anyReallyAny;
        }
    }

    /**
     * 
     * @param appName 
     * @returns 
     */
    private _mapDataWithAppName(appName: APP_NAMES): anyReallyAny {

        let data = undefined;
        switch (appName) {
            case APP_NAMES.PLANNING:
                data = { ...planning };
                break;
            case APP_NAMES.PORTAIL:
                data = null;
                break;
            case APP_NAMES.COMMON:
                data = { ...common };
                break;

            case APP_NAMES.ERROR:
                data = { ...errors };
                break;

            case APP_NAMES.ALERT:
                data = { ...alert };
                break;
            case APP_NAMES.COMPONENTS:
                data = { ...components };
                break;

            default:
                data = null;
                break;
        }

        return data;
    }

}